import { Button } from "@/components/ui/Button";
import { Spinner } from "@/components/ui/Spinner";

export function WorkDescriptionAssistPanel({
  loading,
  suggestedText,
  reason,
  onApply,
}: {
  loading: boolean;
  suggestedText: string | null;
  reason: string | null;
  onApply: () => void;
}) {
  if (!loading && !suggestedText) return null;

  return (
    <div className="mt-2 space-y-2">
      {loading ? (
        <div className="flex items-center gap-2 text-xs text-label-secondary">
          <Spinner className="h-3.5 w-3.5" />
          Formulierung wird vorgeschlagen …
        </div>
      ) : null}
      {suggestedText ? (
        <div className="rounded-ios border border-separator bg-card-elevated p-3 text-sm">
          <div className="mb-1 text-xs text-label-secondary">KI-Vorschlag (Fließtext)</div>
          <div className="whitespace-pre-wrap text-label">{suggestedText}</div>
          {reason ? <div className="mt-2 text-xs text-label-secondary">{reason}</div> : null}
          <Button type="button" size="sm" className="mt-2" onClick={onApply}>
            Vorschlag übernehmen
          </Button>
        </div>
      ) : null}
    </div>
  );
}
